import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import {
  HttpService,
  API,
  swal,
  Title,
  toast,
  Messages,
  DateFormat,
  Spinner
} from '../../../config/react'
import DataTable from 'react-data-table-component'

const CustomerGroup = () => {
  const [CustomerGroupList, setCustomerGroupList] = useState([])
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const columns = [
    {
      name: 'Name',
      sortable: true,
      sortField: 'name',
      selector: (row) => row.name
    },
    {
      name: 'Created Date',
      sortable: true,
      sortField: 'created_at',
      selector: (row) => <DateFormat value={row.created_at}></DateFormat>
    },
    {
      name: 'Status',
      selector: (row) => (row.status === 1 ? <label>Active</label> : <label>Inactive</label>)
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          {row.name.toLowerCase() !== 'general' ? (
            <div className="action-btn">
              <Link
                to={'/system/customer-group/edit/' + row.id}
                className="text-dark"
                title="Edit"
              >
                <i
                  className="fa fa-pencil-square-o"
                  aria-hidden="true"
                ></i>{' '}
              </Link>
              <Link
                onClick={(e) => DeleteCustomerGroup(e, row.id)}
                to=""
                className="text-dark"
                title="Delete"
              >
                <i
                  className="fa fa-trash-o"
                  aria-hidden="true"
                ></i>{' '}
              </Link>
            </div>
          ) : (
            '-'
          )}
        </div>
      )
    }
  ]

  const DefaultFilters = {
    page: 1,
    search: '',
    page_size: 10,
    sort_column: '',
    sort_direction: ''
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const [totalRows, settotalRows] = useState()

  useEffect(() => {
    setIsAuth(true)
    GetCustomerGroupList()
    document.title = Title.CustomerGroup
  }, [CustomFilters])

  const GetCustomerGroupList = () => {
    const passData = {
      page: CustomFilters.page,
      search: CustomFilters.search,
      page_size: CustomFilters.page_size,
      sort_column: CustomFilters.sort_column,
      sort_direction: CustomFilters.sort_direction
    }
    setLoading(true)
    HttpService.postApi(API.GetCustomerGroupsAdminList, passData).then((response) => {
      setLoading(false)
      if (response.data.status === true) {
        const data = response.data.result[1]
        // var data = response.data.result[0];

        setCustomerGroupList(data)
        setForceUpdate(!isForceUpdate)
        settotalRows(response.data.result[0][0].total_row)
      }
    })
  }
  const handlePageChange = (e) => {
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCustomFilters({ ...CustomFilters, page_size: e })
  }

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <input
        type="text"
        title="Search For Name."
        className="form-control col-md-3"
        placeholder="Search"
        onChange={(e) => setCustomFilters({ ...CustomFilters, search: e.target.value })}
      />
    )
  })

  const DeleteCustomerGroup = async (e, id) => {
    e.preventDefault()
    swal(Messages.SwalDeleteProp).then(function (isConfirm) {
      if (isConfirm) {
        const param = {
          id
        }
        setLoading(true)
        HttpService.postApi(API.DeleteCustomerGroup, param).then((response) => {
          setLoading(false)
          toast.success(Messages.RecordDeleted)
          GetCustomerGroupList()
          setForceUpdate(!isForceUpdate)
        })
      }
    })
  }
  const handleSort = (e, direction) => {
    console.log('LN 131 Sort FIeld ' + e.sortField)
    setCustomFilters({
      ...CustomFilters,
      sort_column: e.sortField,
      sort_direction: direction
    })
  }
  return !IsAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.CustomerGroup} </h3>
        <div className="btn-group">
          <Link
            to="/system/customer-group/add"
            className="btn btn-dark btn-fw rounded mr-2"
          >
            {' '}
            Add Customer Group{' '}
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={CustomerGroupList}
                  // progressPending={loading}
                  pagination
                  persistTableHead={true}
                  paginationServer
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  subHeader
                  progressPending={loading}
                  progressComponent={<Spinner />}
                  subHeaderComponent={subHeaderComponentMemo}
                  onSort={handleSort}
                  sortServer
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CustomerGroup
